import { logged_in as loggedIn } from 'state';

export default loggedIn() ? {
  handler: 'showRightSidebarComponent',
  data: () => 'cashout',
} : {
  handler: 'relativeUrl',
  data: () => '/login',
};
